export const scrollToSection = (id: string) => {
	const el = document.getElementById(id);

	if (el) {
		el.scrollIntoView({ behavior: "smooth" });
	} else {
        console.warn(`No element found in the DOM with id "${id}".`);
	}
};